import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { SideNavItems, SideNavSection } from '@modules/navigation/models'
import { NavigationService } from '@modules/navigation/services'
import { EMPTY, Observable, of, Subscription } from 'rxjs'
import { AccountService } from '@services/account.service'
import { AccountProductsService } from '@services/account-products.service'
import { AlertifyService } from '@services/alertify.service'
import { AccountProductType, productCodeByModule } from '@models/account.model'
import { Events } from '@services/events'
import { Router } from '@angular/router'
import { PlatformService } from '@services/platform.service'
import { ProductSubscriptionStatus } from '@utils/product-subscription.util'

@Component({
	selector: 'sb-side-nav',
	templateUrl: './side-nav.component.html',
	styleUrls: ['side-nav.component.scss'],
	standalone: false
})
export class SideNavComponent implements OnInit, OnDestroy {
	subscription = new Subscription()
	sideNavItems$: Observable<SideNavItems> = EMPTY
	sideNavSections$: Observable<SideNavSection[]> = EMPTY

	@Input() sidenavStyle!: string

	@Input() set sideNavItems(value: SideNavItems) {
		this.sideNavItems$ = of(value)
	}

	@Input() set sideNavSections(value: SideNavSection[]) {
		this.sideNavSections$ = of(value)
	}

	protected readonly AccountProductType = AccountProductType
	protected readonly ProductSubscriptionStatus = ProductSubscriptionStatus

	constructor(
		private events: Events,
		private router: Router,
		private alertfy: AlertifyService,
		public accountService: AccountService,
		public accountProducts: AccountProductsService,
		public navigationService: NavigationService,
		public platformService: PlatformService
	) {}

	ngOnInit() {
		this.accountProducts.load()
	}

	ngOnDestroy() {
		this.subscription.unsubscribe()
	}

	toggleSideNav() {
		this.navigationService.toggleSideNav()
	}

	changeProduct(type: AccountProductType) {
		// Módulo cujo produto está inativo (ou fora) da conta não troca de produto: o clique vira
		// apenas o aviso — o item permanece visível para o cliente saber que o módulo existe.
		if (!this.accountProducts.moduleActive(type)) {
			this.alertfy.alert('Produto inativo', this.accountProducts.inactiveMessage(productCodeByModule[type]))
			return
		}

		// Em carência o módulo abre normalmente, mas o aviso aparece — o badge do menu pode passar
		// despercebido (e no mobile não há tooltip).
		const graceMessage = this.accountProducts.moduleGraceMessage(type)

		if (graceMessage) {
			this.alertfy.warning(graceMessage)
		}

		this.accountService.changeProduct(type)

		setTimeout(() => {
			this.events.broadcast('reloadMenu', true)

			const url = type === AccountProductType.SUP ? '/supplier/board' : type === AccountProductType.VIS ? '/visitor/board' : '/dashboard'

			this.router.navigate([url]).then(() => {
				this.navigationService.openedSideNav()
			})
		}, 100)
	}

	activeSectionText(side: SideNavSection) {
		return side?.items?.filter(it => it?.active)?.length > 0
	}

	isSectionHiddenOnMobile(section: SideNavSection): boolean {
		return section?.text === 'SUPORTE' && this.platformService.mobile
	}
}
